import React, { useEffect } from "react";
import { Dialog, DialogContent, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Lottie from "react-lottie";
import DoneTickMark from "../../assets/Lotties/DoneTickMark.json";

export default function DeployedDialog({ open, onClose, isDeployed }) {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: DoneTickMark,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  useEffect(() => {
    setTimeout(() => {
      onClose();
    }, 2000);
  }, [isDeployed]);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      PaperProps={{
        className: "rounded-2xl shadow-xl border border-gray-100 bg-white",
      }}
    >
      {/* Close Icon */}
      <div className="flex justify-end items-center px-4 pt-4">
        <IconButton onClick={onClose} size="small" className="text-gray-500 hover:text-gray-700">
          <CloseIcon />
        </IconButton>
      </div>

      <DialogContent className="flex flex-col justify-center items-center py-6 gap-6">
        <Lottie options={defaultOptions} height={180} width={180} isClickToPauseDisabled />
        <h2 className="text-2xl font-semibold text-gray-800">{isDeployed ? "Deployed" : "Move To Draft"}</h2>
        <p className="text-gray-500 text-center max-w-sm">Your changes were saved successfully</p>
      </DialogContent>
    </Dialog>
  );
}
